
import { defineComponent } from 'vue';
import { OioForm, OioFormItem } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'ProductProperty',
  components: {
    OioForm,
    OioFormItem
  },
  props: ['data'],
  setup(props) {
    const attrFormatter = (item: { values: string[]; customValue: string; name: string; type: string }) => {
      const resArr: string[] = [];
      item.values && resArr.push(...item.values);
      item.customValue && resArr.push(item.customValue);
      return resArr.join(',');
    };

    return {
      attrFormatter
    };
  }
});
